import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ThesisPage from './pages/ThesisPage';
import TeamPage from './pages/TeamPage';
import CompetitionPage from './pages/CompetitionPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/thesis" element={<ThesisPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/competition" element={<CompetitionPage />} />
      </Routes>
    </Router>
  );
}

export default App;
